import _ from 'lodash';
import React from 'react';
import { Progress } from 'reactstrap';
import { cx, PropTypes } from '~/utils';
import { useIdleMonitor } from '~/hooks';
import { useConfig, useGlobalContext } from '~/context';

export function IdleProgress( props ) {
  const config = useConfig();
  const { dispatch } = useGlobalContext();

  const idle = useIdleMonitor( {
    mouse     : false,
    touch     : false,
    timeout   : config.get( `${props.type}Timeout`, 60000 ),
    onExpired : dispatch.reset,
  } );

  const color = pickColor( idle.percent );

  const classes = cx( 'fixed-bottom', 'idle-progress' );
  return (
    <Progress value={idle.percent} color={color} animated className={classes}>
      {idle.seconds} seconds remaining
    </Progress>
  );
}
IdleProgress.propTypes = {
  onExpired   : PropTypes.func,
  type        : PropTypes.oneOf( [ 'swipe', 'error', 'other' ] ),
};
IdleProgress.defaultProps = {
  type        : 'other',
};

function pickColor( percent ) {
  if ( percent <= 20 ) return 'danger';
  if ( percent <= 50 ) return 'warning';
  return 'info';
}
